import { formatCurrency, formatPercentage } from '../../utils/formatters';

function ProfitabilityMetrics({ metrics }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="text-sm text-gray-500">Gross Profit Margin</h3>
        <p className="text-2xl font-bold mt-2">{formatPercentage(metrics.grossProfitMargin)}</p>
        <p className={`text-sm mt-2 ${metrics.grossProfitMarginChange >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {metrics.grossProfitMarginChange > 0 ? '+' : ''}{formatPercentage(metrics.grossProfitMarginChange)} vs. last period
        </p>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="text-sm text-gray-500">Net Profit Margin</h3>
        <p className="text-2xl font-bold mt-2">{formatPercentage(metrics.netProfitMargin)}</p>
        <p className={`text-sm mt-2 ${metrics.netProfitMarginChange >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {metrics.netProfitMarginChange > 0 ? '+' : ''}{formatPercentage(metrics.netProfitMarginChange)} vs. last period
        </p>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="text-sm text-gray-500">Average Order Value</h3>
        <p className="text-2xl font-bold mt-2">{formatCurrency(metrics.averageOrderValue)}</p>
        <p className={`text-sm mt-2 ${metrics.averageOrderValueChange >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {metrics.averageOrderValueChange > 0 ? '+' : ''}{formatPercentage(metrics.averageOrderValueChange)} vs. last period
        </p>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="text-sm text-gray-500">Customer Acquisition Cost</h3>
        <p className="text-2xl font-bold mt-2">{formatCurrency(metrics.customerAcquisitionCost)}</p>
        <p className={`text-sm mt-2 ${metrics.customerAcquisitionCostChange <= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {metrics.customerAcquisitionCostChange > 0 ? '+' : ''}{formatPercentage(metrics.customerAcquisitionCostChange)} vs. last period
        </p>
      </div>
    </div>
  );
}

export default ProfitabilityMetrics;